/**
 * Tailwind palette classes for badges that encode a CATEGORY rather than a state.
 *
 * Tessra's `Badge` only offers semantic variants, and none of them fit: a
 * category like "Text Correctness" rendered as `warning` reads as an error the
 * user has to act on. Until the design system ships a categorical scale, these
 * map onto Tailwind's own palette, which is why they are raw colour classes
 * rather than semantic tokens.
 *
 * Keep every categorical badge pointing here, so swapping to a real scale is
 * one edit.
 *
 * The names come from the palette these badges used before, and two of them are
 * crossed at the source: what it called `blue` painted the paler ramp and what
 * it called `lightBlue` painted the stronger one. The classes below reproduce
 * what actually rendered, not what the names suggest.
 */
export const CATEGORICAL_BADGE_CLASSES = {
  green: 'bg-green-100 text-green-900',
  blue: 'bg-sky-50 text-sky-900',
  lightBlue: 'bg-blue-100 text-blue-900',
  orange: 'bg-orange-100 text-orange-900',
  pink: 'bg-pink-100 text-pink-900',
  red: 'bg-red-100 text-red-900',
  grey: 'bg-neutral-100 text-neutral-900',
} as const;

export type CategoricalBadgeColor = keyof typeof CATEGORICAL_BADGE_CLASSES;

export const categoricalBadgeClass = (color: CategoricalBadgeColor | undefined): string =>
  CATEGORICAL_BADGE_CLASSES[color ?? 'grey'];
